import React, { useEffect, useState } from "react";
import {
  GetPaymentVoucherList,
  GetPaymentVoucherById,
  PaymentVoucherUpdate,
  PaymentVoucherCreate,
  PaymentVoucherDelete,
  GetApproveGVs,
  GetApprovedPVs,
  BankDetailList,
  ApproveAccountsPaymentVoucher,
  GeneratePaymentVoucherNo,
  ExpenseList,
} from "../../../Services/Services";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Modal,
  Box,
  TextField,
  MenuItem,
  Popover,
  Typography,
  Checkbox,
  Autocomplete,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Divider,
  Collapse,
} from "@mui/material";
import {
  Edit,
  Delete,
  Print,
  Visibility,
  Add,
  Close,
} from "@mui/icons-material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { useMediaQuery, useTheme } from "@mui/material";
import { Tooltip } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import AddIcon from "@mui/icons-material/Add";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { generatePaymentPdf } from "../Accounts/PaymentVoucherPrint";
import config from "../../../config";
import { Chip } from "@mui/material";
const PaymentVouchers = () => {
  // ===== States =====
  const [PaymentVouchers, setPaymentVouchers] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [rowErrors, setRowErrors] = useState([]);
  const [rows, setRows] = useState([blankRow()]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editFormData, setEditFormData] = useState({});
  const [open, setOpen] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewData, setViewData] = useState({});
  const [purchaseVoucherData, setPurchaseVoucherData] = useState({});
  const [generalVoucherData, setGeneralVoucherData] = useState({});

  const [anchorEl, setAnchorEl] = useState(null);
  const [voucherToDelete, setVoucherToDelete] = useState(null);
  const [approveAnchorEl, setApproveAnchorEl] = useState(null);
  const [PaymentToApprove, setPaymentToApprove] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const [actionType, setActionType] = useState(null);
  const [showRemarkForIndentId, setShowRemarkForIndentId] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [filters, setFilters] = useState({
    payment_no: "",
    po_no: "",
    supplier: "",
    status: "Pending",
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [expandedVoucher, setExpandedVoucher] = useState(null);

  const [bankDetails, setBankDetails] = useState([]);
  // ===== Initial Data Fetch =====
  useEffect(() => {
    fetchAllData();
  }, []);
  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      fetchVouchers(1, true, filters);
    }, 500);

    return () => clearTimeout(handler);
  }, [filters]);
  const fetchVouchers = async (
    pageNum = 1,
    reset = false,
    filterValues = filters
  ) => {
    const data = await GetPaymentVoucherList(filterValues, pageNum);

    if (reset || pageNum === 1) {
      setPaymentVouchers(
        Array.isArray(data) ? data.results : data.results || []
      );
    } else {
      setPaymentVouchers((prev) => [
        ...prev,
        ...(Array.isArray(data) ? data.results : data.results || []),
      ]);
    }

    setHasMore(Array.isArray(data) ? data.next !== null : data.next !== null);
    setPage(pageNum);
  };
  const fetchMoreData = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchVouchers(nextPage);
  };
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };
  const fetchAllData = async () => {
    try {
      const [General, Purchase, bank, expense] = await Promise.all([
        GetApproveGVs(),
        GetApprovedPVs(),
        BankDetailList(),
        ExpenseList(),
      ]);
      setGeneralVoucherData(
        Array.isArray(General) ? General : General?.results || []
      );
      setPurchaseVoucherData(
        Array.isArray(Purchase) ? Purchase : Purchase?.results || []
      );
      setExpenses(Array.isArray(expense) ? expense : expense?.results || []);
      setBankDetails(Array.isArray(bank) ? bank : bank?.results || []);
    } catch (error) {
      console.error("Data fetch error:", error);
      toast.error("Error fetching initial data");
    }
  };

  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  // ===== Form Utilities =====
  function blankRow() {
    return {
      payment_voucher_no: "",
      payment_number: "",
      project: "",
      voucher_type: "",
      journal_voucher: "",
      division: "",
      supplier: "",
      purchase_voucher: "",
      invoice_number: "",
      amount: "",
      attachment: "",
      payment_mode: "",
      invoice_date: "",
      description: "",
      narration: "",
      expense: "",
    };
  }

  const handleRowChange = (index, e) => {
    const { name, value } = e.target;
    setRows((prev) => {
      const updated = [...prev];
      updated[index][name] = value;
      return updated;
    });
  };

  const addRow = () => setRows([...rows, blankRow()]);
  const removeRow = (index) => setRows(rows.filter((_, i) => i !== index));

  // ===== Modal Handlers =====
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setRows([blankRow()]);
    setOpen(false);
  };
  const fetchNextPvNo = async () => {
    const data = await GeneratePaymentVoucherNo();
    if (data && data.payment_voucher_no) {
      setRows((prev) => {
        const updated = [...prev];
        // sirf first row ka voucher no set karo
        if (updated.length > 0) {
          updated[0] = {
            ...updated[0],
            payment_number: data.payment_voucher_no,
          };
        }
        return updated;
      });
    }
  };

  const handleEditClick = async (id) => {
    const data = await GetPaymentVoucherById(id);
    if (data) {
      setEditFormData(data);
      setEditModalOpen(true);
    }
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleView = (voucher) => {
    setViewData(voucher);
    setViewModalOpen(true);
  };
  const userId = Number(localStorage.getItem("user_id"));

  // ===== Submit Handlers =====
  const handleSubmit = async (e) => {
    e.preventDefault();
    const timestamp = Date.now();

    const newData = rows.map((row, i) => ({
      ...row,
      created_by: userId,
      id: timestamp + i,
    }));
    for (const row of newData) {
      try {
        if (!validateForm(row)) return;

        const formData = new FormData();
        formData.append("payment_voucher_no", row.payment_voucher_no || "");
        formData.append("payment_number", row.payment_number || "");
        formData.append("project", row.project || "");
        formData.append("division", row.division || "");
        formData.append("supplier", row.supplier || "");
        formData.append("invoice_date", row.invoice_date || "");
        formData.append("invoice_number", row.invoice_number || "");
        formData.append("journal_voucher", row.journal_voucher || "");
        formData.append("purchase_voucher", row.purchase_voucher || "");
        formData.append("expense", row.expense || "");
        formData.append("amount", row.amount || "");
        formData.append("payment_mode", row.payment_mode || "");
        formData.append("narration", row.narration || "");
        formData.append("description", row.description || "");
        formData.append("bank", row.bank || "");
        formData.append("created_by", row.created_by);
        formData.append("voucher_type", row.voucher_type || "");
        // 🔑 File sirf tab append karo jab actual File ho
        if (row.attachment instanceof File) {
          formData.append("attachment", row.attachment);
        }

        await PaymentVoucherCreate(formData); // JSON nahi, FormData bhejna hai
      } catch (error) {
        console.error("❌ Failed to submit row:", row, error);
      }
    }

    const updatedList = await GetPaymentVoucherList(); // 🔄 Refresh table
    setPaymentVouchers(updatedList);
    toast.success("Voucher(s) added successfully");
    handleClose();
  };

  const handleEditSave = async () => {
    try {
      if (!validateForm(editFormData)) {
        toast.error("Please fill all required fields.");
        return;
      }
      const formData = new FormData();
      formData.append(
        "payment_voucher_no",
        editFormData.payment_voucher_no || ""
      );
      formData.append("payment_number", editFormData.payment_number || "");
      formData.append("project", editFormData.project || "");
      formData.append("division", editFormData.division || "");
      formData.append("supplier", editFormData.supplier || "");
      formData.append("invoice_date", editFormData.invoice_date || "");
      formData.append("invoice_number", editFormData.invoice_number || "");
      formData.append("journal_voucher", editFormData.journal_voucher || "");
      formData.append("purchase_voucher", editFormData.purchase_voucher || "");
      formData.append("expense", editFormData.expense || "");
      formData.append("amount", editFormData.amount || "");
      formData.append("narration", editFormData.narration || "");
      formData.append("description", editFormData.description || "");
      formData.append("bank", editFormData.bank || "");
      formData.append("payment_mode", editFormData.payment_mode || "");
      formData.append("voucher_type", editFormData.voucher_type || "");
      // 🔑 File sirf tabhi append karo jab vo File ho
      if (editFormData.attachment instanceof File) {
        formData.append("attachment", editFormData.attachment);
      }

      const response = await PaymentVoucherUpdate(
        editFormData.payment_voucher_no,
        formData // ab JSON nahi, FormData ja raha hai
      );

      setPaymentVouchers(response);
      setEditModalOpen(false);
      toast.success("Updated successfully!");
    } catch (error) {
      console.error("Update error:", error.response?.data || error.message);
      toast.error("Update failed.");
    }
  };

  const handleDelete = async (voucherId) => {
    try {
      await PaymentVoucherDelete(voucherId); // DELETE API
      const updatedList = await GetPaymentVoucherList(); // GET latest
      setPaymentVouchers(updatedList); // Update table
      toast.success("Deleted successfully!");
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Delete failed.");
    }
  };

  const handleApprove = async (voucher) => {
    const approvedById = Number(localStorage.getItem("user_id"));
    if (!approvedById) {
      toast.error("Approver ID not found.");
      return;
    }

    try {
      const updated = await ApproveAccountsPaymentVoucher(
        voucher.payment_voucher_no, // <-- important change
        approvedById,
        voucher.status,
        remarkInput
      );

      setPaymentVouchers((prev) =>
        prev.map((item) =>
          item.payment_voucher_no == updated.payment_voucher_no ? updated : item
        )
      );

      toast.success("Payment Voucher approved successfully!");
    } catch (error) {
      console.error("Approval Error:", error);
      toast.error("Failed to approve Payment Voucher.");
    }
  };
  const userRole = localStorage.getItem("role"); // "admin" ya "staff"
  const validateForm = (data) => {
    const errors = {};
    const rowErrs = [];

    // if (!data.invoice_date) errors.invoice_date = "Required";
    // if (!data.invoice_number) errors.invoice_number = "Required";
    if (!data.amount) errors.amount = "Required";
    // if (!data.attachment) errors.attachment = "Required";

    setFormErrors(errors);
    setRowErrors(rowErrs);

    return (
      Object.keys(errors).length === 0 &&
      rowErrs.every((e) => Object.keys(e).length === 0)
    );
  };

  useEffect(() => {
    document.body.style.overflow = isMobile ? 'auto' : 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMobile]);
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (

    <>
      <ToastContainer />

      {/* ✅ Responsive Filters */}
      <Box
        display="flex"
        flexWrap={{ xs: "wrap", md: "nowrap" }} // ✅ Mobile mein wrap, Desktop mein nowrap
        alignItems="center"
        sx={{
          mt: -3,
          pt: -3,
          mb: 1,
          width: "100%",
          gap: 2,
        }}
      >
        {/* Radio Buttons */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexShrink: 0,
            whiteSpace: "nowrap",
            width: { xs: "100%", md: "auto" }, // ✅ Mobile mein full width
            justifyContent: { xs: "space-around", md: "flex-start" }, // ✅ Mobile mein center
          }}
        >
          <input
            type="radio"
            id="pending"
            name="status"
            value="Pending"
            checked={filters.status === "Pending"}
            onChange={handleFilterChange}
            style={{
              marginLeft: "10px",
              width: "10px",
              height: "10px",
              verticalAlign: "middle",
            }}
          />
          <label htmlFor="pending" style={{ fontSize: "12px" }}>
            Pending
          </label>

          <input
            type="radio"
            id="approved"
            name="status"
            value="Approved"
            checked={filters.status === "Approved"}
            onChange={handleFilterChange}
            style={{
              marginLeft: "10px",
              width: "10px",
              height: "10px",
              verticalAlign: "middle",
            }}
          />
          <label htmlFor="approved" style={{ fontSize: "12px" }}>
            Approved
          </label>

          <input
            type="radio"
            id="rejected"
            name="status"
            value="Rejected"
            checked={filters.status === "Rejected"}
            onChange={handleFilterChange}
            style={{
              marginLeft: "10px",
              width: "10px",
              height: "10px",
              verticalAlign: "middle",
            }}
          />
          <label htmlFor="rejected" style={{ fontSize: "12px" }}>
            Rejected
          </label>
        </Box>

        {/* Search Fields Container */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flex: 1,
            width: "100%",
            flexDirection: { xs: "column", md: "row" }, // ✅ Mobile mein column, Desktop mein row
          }}
        >
          <TextField
            label="Payment Voucher No"
            name="payment_no"
            size="small"
            value={filters.payment_no}
            onChange={handleFilterChange}
            sx={{
              flex: { xs: "none", md: "1 1 150px" }, // ✅ Desktop mein flex
              width: { xs: "100%", md: "auto" }, // ✅ Mobile mein full width
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.65rem",
              },
            }}
          />
          <TextField
            label="PO No"
            name="po_no"
            size="small"
            value={filters.po_no}
            onChange={handleFilterChange}
            sx={{
              flex: { xs: "none", md: "1 1 150px" },
              width: { xs: "100%", md: "auto" },
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.65rem",
              },
            }}
          />
          <TextField
            label="Supplier"
            name="supplier"
            size="small"
            value={filters.supplier}
            onChange={handleFilterChange}
            sx={{
              flex: { xs: "none", md: "1 1 150px" },
              width: { xs: "100%", md: "auto" },
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.65rem",
              },
            }}
          />
        </Box>
      </Box>


      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "600px",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
            {rows.map((row, index) => (
              <Box
                key={index}
                sx={{
                  mb: 2,
                  backgroundColor: "#f5f7fa",
                  borderRadius: 2,
                  border: "1px solid #e0e0e0",
                  p: 2,
                }}
              >
                <Grid container spacing={2}>
                  {/* Row 1 */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Voucher No."
                      name="payment_number"
                      value={row.payment_number || ""}
                      size="small"
                      disabled
                      sx={{ width: 500 }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Invoice No."
                      name="invoice_number"
                      value={row.invoice_number || ""}
                      onChange={(e) => handleRowChange(index, e)}
                      size="small"
                      error={!!formErrors.invoice_number}
                      sx={{ width: 500 }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Invoice Date"
                      name="invoice_date"
                      type="date"
                      value={row.invoice_date || ""}
                      onChange={(e) => handleRowChange(index, e)}
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      error={!!formErrors.invoice_date}
                      sx={{ width: 500 }}
                    />
                  </Grid>
                  {/* ==== Radio Group Row ==== */}
                  <Grid item xs={12}>
                    <FormControl component="fieldset">
                      <FormLabel component="legend">
                        Select Voucher Type
                      </FormLabel>
                      <RadioGroup
                        row
                        value={row.voucher_type || ""}
                        onChange={(e) =>
                          handleRowChange(index, {
                            target: {
                              name: "voucher_type",
                              value: e.target.value,
                            },
                          })
                        }
                      >
                        <FormControlLabel
                          value="journal"
                          control={<Radio />}
                          label="Journal Voucher"
                        />
                        <FormControlLabel
                          value="purchase"
                          control={<Radio />}
                          label="Purchase Voucher"
                        />
                        <FormControlLabel
                          value="expense"
                          control={<Radio />}
                          label="Expense"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  {/* ==== Conditionally Render Dropdown ==== */}
                  {row.voucher_type === "journal" && (
                    <Grid item xs={12}>
                      <Autocomplete
                        options={generalVoucherData}
                        getOptionLabel={(option) => option.gen_number || ""}
                        value={
                          (Array.isArray(generalVoucherData) &&
                            generalVoucherData.find(
                              (d) => d.gen_voucher_no === row.journal_voucher
                            )) ||
                          null
                        }
                        onChange={(e, newValue) => {
                          handleRowChange(index, {
                            target: {
                              name: "journal_voucher",
                              value: newValue ? newValue.gen_voucher_no : "",
                            },
                          });

                          if (newValue) {
                            handleRowChange(index, {
                              target: {
                                name: "division",
                                value: newValue.division || "",
                              },
                            });

                            handleRowChange(index, {
                              target: {
                                name: "division_name",
                                value: newValue.division_name || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "project",
                                value: newValue.project?.id || "",
                              },
                            });

                            handleRowChange(index, {
                              target: {
                                name: "project_name",
                                value: newValue.project?.project_name || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "imprest",
                                value: newValue.imprest || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "imprest_name",
                                value: newValue.imprest_name || "",
                              },
                            });

                            handleRowChange(index, {
                              target: {
                                name: "expense",
                                value: newValue.expense || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "expense_name",
                                value: newValue.expense_name || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "amount",
                                value: newValue.amount.toFixed(2) || "",
                              },
                            });
                          } else {
                            // Reset if cleared
                            [
                              "division",
                              "division_name",
                              "project",
                              "project_name",
                              "imprest",
                              "expense",
                              "amount",
                            ].forEach((field) =>
                              handleRowChange(index, {
                                target: { name: field, value: "" },
                              })
                            );
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Journal Voucher No"
                            size="small"
                            error={!!formErrors.transporter_name}
                            helperText={formErrors.transporter_name}
                            sx={{ width: 500 }}
                          />
                        )}
                      />
                    </Grid>
                  )}

                  {row.voucher_type === "purchase" && (
                    <Grid item xs={12}>
                      <Autocomplete
                        options={purchaseVoucherData}
                        getOptionLabel={(option) =>
                          option.purchase_number || ""
                        }
                        value={
                          (Array.isArray(purchaseVoucherData) &&
                            purchaseVoucherData.find(
                              (d) =>
                                d.purchase_voucher_no === row.purchase_voucher
                            )) ||
                          null
                        }
                        onChange={(e, newValue) => {
                          handleRowChange(index, {
                            target: {
                              name: "purchase_voucher",
                              value: newValue
                                ? newValue.purchase_voucher_no
                                : "",
                            },
                          });

                          if (newValue) {
                            handleRowChange(index, {
                              target: {
                                name: "division",
                                value: newValue.division || "",
                              },
                            });

                            handleRowChange(index, {
                              target: {
                                name: "division_name",
                                value: newValue.division_name || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "project",
                                value: newValue.project || "",
                              },
                            });

                            handleRowChange(index, {
                              target: {
                                name: "project_name",
                                value: newValue.project_name || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "supplier",
                                value: newValue.supplier || "",
                              },
                            });

                            handleRowChange(index, {
                              target: {
                                name: "supplier_name",
                                value: newValue.supplier_name || "",
                              },
                            });

                            handleRowChange(index, {
                              target: {
                                name: "amount",
                                value: newValue.amount.toFixed(2) || "",
                              },
                            });
                          } else {
                            // Reset if cleared
                            [
                              "division",
                              "division_name",
                              "project",
                              "project_name",
                              "imprest",
                              "expense",
                              "amount",
                            ].forEach((field) =>
                              handleRowChange(index, {
                                target: { name: field, value: "" },
                              })
                            );
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Purchase Voucher No"
                            size="small"
                            error={!!formErrors.transporter_name}
                            helperText={formErrors.transporter_name}
                            sx={{ width: 500 }}
                          />
                        )}
                      />
                    </Grid>
                  )}
                  {(row.voucher_type === "purchase" ||
                    row.voucher_type === "journal") && (
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Project"
                          name="project_name"
                          size="small"
                          value={row.project_name || ""}
                          disabled
                          sx={{ width: 500 }}
                        />
                      </Grid>
                    )}
                  {(row.voucher_type === "purchase" ||
                    row.voucher_type === "journal") && (
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Division"
                          name="division_name"
                          size="small"
                          value={row.division_name || ""}
                          disabled
                          sx={{ width: 500 }}
                        />
                      </Grid>
                    )}
                  {row.voucher_type === "purchase" && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Supplier"
                        name="supplier_name"
                        size="small"
                        value={row.supplier_name || ""}
                        disabled
                        sx={{ width: 500 }}
                      />
                    </Grid>
                  )}
                  {row.voucher_type === "expense" && (
                    <>
                      {/* Expense Autocomplete */}
                      <Grid item xs={12}>
                        <Autocomplete
                          options={expenses || []}
                          getOptionLabel={(option) => option.expense || ""}
                          value={
                            expenses?.find(
                              (expense) => expense.expense_id === row.expense
                            ) || null
                          }
                          onChange={(e, newValue) => {
                            handleRowChange(index, {
                              target: {
                                name: "expense",
                                value: newValue ? newValue.expense_id : "",
                              },
                            });

                            handleRowChange(index, {
                              target: {
                                name: "expense_name",
                                value: newValue ? newValue.expense : "",
                              },
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Expense"
                              size="small"
                              sx={{ width: 500 }}
                            />
                          )}
                        />
                      </Grid>

                      {/* Amount Input Field */}
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Amount"
                          name="amount"
                          size="small"
                          type="number"
                          value={row.amount || ""}
                          onChange={(e) => handleRowChange(index, e)}
                          inputProps={{ min: 0, step: 0.01 }}
                          sx={{ width: 500 }}
                        />
                      </Grid>
                    </>
                  )}

                  {/* ==== Journal Voucher specific fields ==== */}
                  {row.voucher_type === "journal" && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Imprest Acc"
                        name="imprest"
                        size="small"
                        value={row.imprest_name || ""}
                        disabled
                        sx={{ width: 500 }}
                      />
                    </Grid>
                  )}
                  {row.voucher_type === "journal" && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Expense"
                        name="expense"
                        size="small"
                        value={row.expense_name || ""}
                        disabled
                        sx={{ width: 500 }}
                      />
                    </Grid>
                  )}
                  {(row.voucher_type === "purchase" ||
                    row.voucher_type === "journal") && (
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Amount"
                          name="amount"
                          size="small"
                          value={row.amount || ""}
                          disabled
                          sx={{ width: 500 }}
                        />
                      </Grid>
                    )}
                  {/* ==== Cash / Bank Radio ==== */}
                  <Grid item xs={12}>
                    <FormControl component="fieldset">
                      <FormLabel component="legend">Payment Mode</FormLabel>
                      <RadioGroup
                        row
                        value={row.payment_mode || ""}
                        onChange={(e) =>
                          handleRowChange(index, {
                            target: {
                              name: "payment_mode",
                              value: e.target.value,
                            },
                          })
                        }
                      >
                        <FormControlLabel
                          value="Cash"
                          control={<Radio />}
                          label="Cash"
                        />
                        <FormControlLabel
                          value="Bank"
                          control={<Radio />}
                          label="Bank"
                        />
                        <FormControlLabel
                          value="Cheque"
                          control={<Radio />}
                          label="Cheque/NEFT/RTGS/UPI"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  {/* ==== Conditionally show TextField ==== */}
                  {row.payment_mode === "Cash" && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Cash Details"
                        name="description"
                        value={row.description || ""}
                        onChange={(e) => handleRowChange(index, e)}
                        size="small"
                        sx={{ width: 500 }}
                      />
                    </Grid>
                  )}

                  {row.payment_mode === "Cheque" && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Bank Details"
                        name="description"
                        value={row.description || ""}
                        onChange={(e) => handleRowChange(index, e)}
                        size="small"
                        placeholder="NEFT/RTGS/UPI/Cheque"
                        sx={{ width: 500 }}
                      />
                    </Grid>
                  )}

                  {row.payment_mode === "Bank" && (
                    <Grid item xs={12}>
                      <Autocomplete
                        options={bankDetails}
                        getOptionLabel={(option) => option.account_number}
                        value={bankDetails.find(
                          (option) => option.id === row.bank
                        )}
                        onChange={(e, newValue) => {
                          handleRowChange(index, {
                            target: {
                              name: "bank",
                              value: newValue ? newValue.id : null,
                            },
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Bank Details"
                            size="small"
                            sx={{ width: 500 }}
                          />
                        )}
                      />
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Narration"
                      name="narration"
                      value={row.narration || ""}
                      onChange={(e) => handleRowChange(index, e)}
                      size="small"
                      sx={{ width: 500 }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      type="file"
                      name="attachment"
                      id={`attachment-${index}`}
                      onChange={(e) => handleRowChange(index, e)}
                      label="Attachment"
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      error={!!formErrors.attachment}
                      sx={{ width: 500 }}
                    />
                  </Grid>

                  {/* Remove Button */}
                  <Grid item xs={12}>
                    {rows.length > 1 && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <Button
                          variant="outlined"
                          color="error"
                          onClick={() => removeRow(index)}
                          size="small"
                          startIcon={<Close fontSize="small" />}
                          sx={{ textTransform: "none", fontWeight: 500 }}
                        >
                          Remove
                        </Button>
                      </Box>
                    )}
                  </Grid>
                </Grid>
              </Box>
            ))}
          </Box>

          {/* Footer Buttons */}
          <Box
            sx={{
              borderTop: "1px solid #ddd",
              p: 2,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              backgroundColor: "#fafafa",
              gap: 1,
            }}
          >
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="outlined"
                onClick={handleSubmit}
                size="small"
                sx={{ px: 2, fontWeight: 500 }}
              >
                Submit
              </Button>
              <Button
                variant="contained"
                onClick={handleClose}
                size="small"
                sx={{ px: 2 }}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <InfiniteScroll
        dataLength={PaymentVouchers.length}
        next={fetchMoreData}
        hasMore={hasMore}
        loader={<h4>Loading...</h4>}
      >
        {isMobile ? (
          /* 📱 MOBILE VIEW - Expandable Cards */
          <Box
            sx={{
              bgcolor: "background.paper",
              maxHeight: "88vh",
              overflow: "auto",
            }}
          >
            {PaymentVouchers.map((voucher, index) => (
              <Box key={voucher.id || index}>
                {/* Main Row - Always Visible */}
                <Box
                  onClick={() =>
                    setExpandedVoucher(
                      expandedVoucher === voucher.id ? null : voucher.id
                    )
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.5,
                    cursor: "pointer",
                    bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                    "&:active": {
                      bgcolor: "#e3f2fd",
                    },
                    borderLeft: `4px solid ${voucher.status === "Approved"
                      ? "#4caf50"
                      : voucher.status === "Rejected"
                        ? "#f44336"
                        : "#ff9800"
                      }`,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    {/* Voucher Number & Amount */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 0.5,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#666",
                          minWidth: 25,
                        }}
                      >
                        #{index + 1}
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.85rem",
                          flex: 1,
                        }}
                      >
                        {voucher.payment_number}
                      </Typography>
                      {/* <Chip
                        label={
                          voucher.status === "Approved"
                            ? "✓"
                            : voucher.status === "Rejected"
                              ? "✗"
                              : "⏱"
                        }
                        color={
                          voucher.status === "Approved"
                            ? "success"
                            : voucher.status === "Rejected"
                              ? "error"
                              : "warning"
                        }
                        size="small"
                        sx={{
                          // fontSize: "0.2rem", // 👈 font chhota hoga
                          height: "10px",
                          transform: "scale(0.8)",
                          "& .MuiChip-label": {
                            padding: "0 6px",
                          },
                        }}
                      /> */}
                    </Box>

                    {/* Amount & Date */}
                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        color: "#666",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <span style={{ fontWeight: 600, color: "#2e7d32" }}>
                        ₹{voucher.total_amount?.toLocaleString("en-IN")}
                      </span>
                      <span style={{ color: "#999" }}>•</span>
                      <span style={{ fontSize: "0.7rem" }}>
                        {formatDate(voucher.created_at)}
                      </span>
                    </Typography>
                  </Box>

                  {/* Expand Icon */}
                  <IconButton size="small" sx={{ ml: 1 }}>
                    {expandedVoucher === voucher.id ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </IconButton>
                </Box>

                {/* Expanded Details */}
                <Collapse
                  in={expandedVoucher === voucher.id}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box
                    sx={{
                      px: 1.5,
                      py: 1,
                      bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
                      borderLeft: `4px solid ${voucher.status === "Approved"
                        ? "#4caf50"
                        : voucher.status === "Rejected"
                          ? "#f44336"
                          : "#ff9800"
                        }`,
                    }}
                  >
                    {/* Details Grid */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 0.8,
                        mb: 1,
                      }}
                    >
                      {/* Project */}
                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          PROJECT
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            color: "#333",
                          }}
                        >
                          {voucher.project_name || "N/A"}
                        </Typography>
                      </Box>

                      {/* Division */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          DIVISION
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.division_name || "N/A"}
                        </Typography>
                      </Box>

                      {/* Payment Mode */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          PAYMENT MODE
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.payment_mode || "N/A"}
                        </Typography>
                      </Box>

                      {/* Ledger Name */}
                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          LEDGER NAME
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.supplier_name ||
                            voucher.expense_name ||
                            voucher.advanceworker_name ||
                            voucher.imprest_name ||
                            voucher.party_name ||
                            "N/A"}
                        </Typography>
                      </Box>

                      {/* Created By */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          CREATED BY
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.created_by_name || "N/A"}
                        </Typography>
                      </Box>

                      {/* Approved By */}
                      {voucher.approved_name && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            APPROVED BY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {voucher.approved_name}
                          </Typography>
                        </Box>
                      )}

                      {/* Payment Date */}
                      {voucher.payment_date && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            PAYMENT DATE
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {voucher.payment_date}
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    {/* Remarks */}
                    {voucher.remarks && (
                      <Box sx={{ mb: 0.8 }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                            mb: 0.3,
                          }}
                        >
                          REMARKS
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#555",
                            fontStyle: "italic",
                            lineHeight: 1.3,
                          }}
                        >
                          {voucher.remarks}
                        </Typography>
                      </Box>
                    )}

                    <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

                    {/* Action Buttons */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      {/* Approve - Only Admin */}
                      {userRole != "Staff" && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            bgcolor:
                              voucher.status === "Approved"
                                ? "#e8f5e9"
                                : voucher.status === "Rejected"
                                  ? "#ffebee"
                                  : "#fff3e0",
                            px: 1,
                            py: 0.5,
                            borderRadius: "6px",
                            border: `1px solid ${voucher.status === "Approved"
                              ? "#4caf50"
                              : voucher.status === "Rejected"
                                ? "#f44336"
                                : "#ff9800"
                              }`,
                          }}
                        >
                          <Checkbox
                            checked={
                              voucher.status === "Approved" ||
                              voucher.status === "Rejected"
                            }
                            onChange={(e) => {
                              e.stopPropagation();
                              setApproveAnchorEl(e.currentTarget);
                              setPaymentToApprove(voucher);
                            }}
                            sx={{
                              padding: 0,
                              transform: "scale(0.75)",
                              color:
                                voucher.status === "Approved"
                                  ? "#4caf50"
                                  : voucher.status === "Rejected"
                                    ? "#f44336"
                                    : "#ff9800",
                              "&.Mui-checked": {
                                color:
                                  voucher.status === "Approved"
                                    ? "#4caf50"
                                    : "#f44336",
                              },
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              fontWeight: 600,
                              color:
                                voucher.status === "Approved"
                                  ? "#2e7d32"
                                  : voucher.status === "Rejected"
                                    ? "#c62828"
                                    : "#f57c00",
                            }}
                          >
                            {voucher.status === "Approved"
                              ? "Approved"
                              : voucher.status === "Rejected"
                                ? "Rejected"
                                : "Approve"}
                          </Typography>
                        </Box>
                      )}

                      {/* Print & View Buttons */}
                      <Box sx={{ display: "flex", gap: 0.6 }}>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            generatePaymentPdf(voucher);
                          }}
                          sx={{
                            bgcolor: "#fff3e0",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#ffe0b2",
                              transform: "scale(1.05)",
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Print sx={{ fontSize: "1rem", color: "#f57c00" }} />
                        </IconButton>

                        {typeof voucher.attachment === "string" ? (
                          <a
                            href={`${voucher.attachment}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <IconButton
                              size="small"
                              sx={{
                                bgcolor: "#e3f2fd",
                                borderRadius: "6px",
                                width: 32,
                                height: 32,
                                "&:hover": {
                                  bgcolor: "#bbdefb",
                                  transform: "scale(1.05)",
                                },
                                transition: "all 0.2s",
                              }}
                            >
                              <Visibility
                                sx={{ fontSize: "1rem", color: "#1976d2" }}
                              />
                            </IconButton>
                          </a>
                        ) : voucher.attachment instanceof File ? (
                          <a
                            href={URL.createObjectURL(voucher.attachment)}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <IconButton
                              size="small"
                              sx={{
                                bgcolor: "#e3f2fd",
                                borderRadius: "6px",
                                width: 32,
                                height: 32,
                                "&:hover": {
                                  bgcolor: "#bbdefb",
                                  transform: "scale(1.05)",
                                },
                                transition: "all 0.2s",
                              }}
                            >
                              <Visibility
                                sx={{ fontSize: "1rem", color: "#1976d2" }}
                              />
                            </IconButton>
                          </a>
                        ) : null}
                      </Box>
                    </Box>
                  </Box>
                </Collapse>

                {/* Divider between items */}
                <Divider />
              </Box>
            ))}

            {/* Mobile Total Summary */}
            <Box
              sx={{
                p: 2,
                bgcolor: "#e3f2fd",
                position: "sticky",
                bottom: 0,
                borderTop: "2px solid #1976d2",
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.85rem",
                  fontWeight: "bold",
                  color: "#1976d2",
                  textAlign: "center",
                }}
              >
                Total Amount: ₹
                {PaymentVouchers.reduce(
                  (sum, v) => sum + parseFloat(v.total_amount || 0),
                  0
                ).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </Box>
          </Box>
        ) : (
          /* 💻 DESKTOP VIEW - Table */
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: "88vh",
              overflow: "auto",
            }}
          >
            <Table
              stickyHeader
              size="small"
              sx={{
                minWidth: 1600,
                "& td, & th": {
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  backgroundColor: "#f5f5f5",
                  borderBottom: "1px solid #ccc",
                },
              }}
            >
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "& th": {
                      fontWeight: "bold",
                      color: "#333",
                      borderBottom: "1px solid #999",
                      whiteSpace: "nowrap",
                      fontSize: "0.75rem",
                    },
                  }}
                >
                  {userRole != "Staff" && (
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 0,
                        backgroundColor: "#fafafa",
                        zIndex: 3,
                      }}
                    >
                      Approve
                    </TableCell>
                  )}
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: userRole != "Staff" ? 80 : 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                    }}
                  >
                    S.No.
                  </TableCell>
                  <TableCell>Voucher No</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Paid Amt</TableCell>
                  <TableCell>Project</TableCell>
                  <TableCell>Division</TableCell>
                  <TableCell>Ladger Name</TableCell>
                  <TableCell>Payment Mode</TableCell>
                  <TableCell>Payment Date</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Created By</TableCell>
                  <TableCell>Approved By</TableCell>
                  <TableCell>Remarks</TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {PaymentVouchers.map((voucher, index) => (
                  <TableRow
                    hover
                    key={index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                      "&:hover": {
                        backgroundColor: "#e3f2fd",
                        "& td": {
                          backgroundColor: "#e3f2fd !important",
                        },
                      },
                      "& td": {
                        paddingRight: "13px !important",
                        paddingLeft: "13px !important",
                        padding: "0px",
                        fontSize: { xs: "0.65rem", sm: "0.75rem" },
                        whiteSpace: "nowrap",
                        color: (theme) =>
                          theme.palette.mode === "dark" ? "white" : "inherit",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark" ? "black" : "inherit",
                      },
                    }}
                  >
                    {userRole != "Staff" && (
                      <TableCell
                        sx={{
                          position: "sticky",
                          left: 0,
                          backgroundColor: "#fafafa",
                          // zIndex: 3,
                        }}
                      >
                        <Checkbox
                          checked={
                            voucher.status === "Approved" ||
                            voucher.status === "Rejected"
                          }
                          onChange={(e) => {
                            setApproveAnchorEl(e.currentTarget);
                            setPaymentToApprove(voucher);
                          }}
                          sx={{
                            padding: 0,
                            paddingLeft: 1,
                            paddingRight: 1,
                            transform: "scale(0.6)",
                            color:
                              voucher.status === "Approved"
                                ? "green"
                                : voucher.status === "Rejected"
                                  ? "red"
                                  : "grey",
                            "&.Mui-checked": {
                              color:
                                voucher.status === "Approved" ? "green" : "red",
                            },
                          }}
                        />
                      </TableCell>
                    )}
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: userRole != "Staff" ? 80 : 0,
                        backgroundColor: "#f5f5f5",
                        // zIndex: 3,
                      }}
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell>{voucher.payment_number}</TableCell>
                    <TableCell align="center">
                      <Chip
                        label={
                          voucher.status === "Approved"
                            ? "Approved"
                            : voucher.status === "Rejected"
                              ? "Rejected"
                              : "Pending"
                        }
                        color={
                          voucher.status === "Approved"
                            ? "success"
                            : voucher.status === "Rejected"
                              ? "error"
                              : "warning"
                        }
                        variant="outlined"
                        size="small"
                        sx={{
                          // fontSize: "0.2rem", // 👈 font chhota hoga
                          height: "10px",
                          transform: "scale(0.8)",
                          "& .MuiChip-label": {
                            padding: "0 6px",
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      {voucher.total_amount?.toLocaleString("en-IN")}
                    </TableCell>
                    <TableCell>{voucher.project_name}</TableCell>
                    <TableCell>{voucher.division_name}</TableCell>
                    <TableCell>
                      {voucher.supplier_name ||
                        voucher.expense_name ||
                        voucher.advanceworker_name ||
                        voucher.imprest_name ||
                        voucher.party_name}
                    </TableCell>
                    <TableCell>{voucher.payment_mode}</TableCell>
                    <TableCell>{voucher.payment_date}</TableCell>
                    <TableCell>{formatDate(voucher.created_at)}</TableCell>
                    <TableCell>{voucher.created_by_name}</TableCell>
                    <TableCell>{voucher.approved_name}</TableCell>
                    <TableCell>
                      <Tooltip title={voucher.remarks || ""} arrow>
                        <span>{truncateText(voucher.remarks || "", 20)}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell
                      sx={{
                        position: "sticky",
                        right: 0,
                        backgroundColor: "#f5f5f5",
                        // zIndex: 3,
                        minWidth: 180,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 0.5,
                        }}
                      >
                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          color="warning"
                          size="small"
                          onClick={() => generatePaymentPdf(voucher)}
                        >
                          <Print transform="scale(0.6)" />
                        </IconButton>
                        <span
                          style={{
                            display: "inline-block",
                            width: 36,
                            textAlign: "center",
                          }}
                        >
                          {typeof voucher.attachment === "string" ? (
                            <a
                              href={`${voucher.attachment}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <IconButton
                                sx={{
                                  padding: 0,
                                  paddingLeft: 1,
                                  paddingRight: 1,
                                }}
                                color="info"
                                size="small"
                              >
                                <Visibility transform="scale(0.6)" />
                              </IconButton>
                            </a>
                          ) : voucher.attachment instanceof File ? (
                            <a
                              href={URL.createObjectURL(voucher.attachment)}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <IconButton
                                sx={{
                                  padding: 0,
                                  paddingLeft: 1,
                                  paddingRight: 1,
                                }}
                                color="info"
                                size="small"
                              >
                                <Visibility fontSize="small" />
                              </IconButton>
                            </a>
                          ) : (
                            <span
                              style={{ display: "inline-block", width: 24 }}
                            />
                          )}
                        </span>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow
                  sx={{
                    "& td": {
                      backgroundColor: "#E3F2FD !important",
                    },
                  }}
                >
                  <TableCell
                    colSpan={4}
                    align="right"
                    sx={{
                      fontWeight: "bold !important",
                    }}
                  >
                    Totals:
                  </TableCell>
                  <TableCell>
                    {PaymentVouchers.reduce(
                      (sum, v) => sum + parseFloat(v.total_amount || 0),
                      0
                    ).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </TableCell>
                  <TableCell colSpan={9}></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </InfiniteScroll>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setVoucherToDelete(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="body2">Are you sure?</Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Button
              color="error"
              size="small"
              onClick={async () => {
                await handleDelete(voucherToDelete);
                setAnchorEl(null);
                setVoucherToDelete(null);
              }}
            >
              Yes
            </Button>
            <Button
              size="small"
              onClick={() => {
                setAnchorEl(null);
                setVoucherToDelete(null);
              }}
            >
              No
            </Button>
          </Box>
        </Box>
      </Popover>

      {/* approve pop */}

      <Popover
        open={Boolean(approveAnchorEl)}
        anchorEl={approveAnchorEl}
        onClose={() => {
          setApproveAnchorEl(null);
          setPaymentToApprove(null);
          setRemarkInput("");
          setShowRemarkForIndentId(null);
          setActionType(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 2, minWidth: 250 }}>
          {showRemarkForIndentId === PaymentToApprove?.payment_voucher_no ? (
            <>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Please enter remark before{" "}
                {actionType === "Approved" ? "approving" : "rejecting"}:
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={remarkInput}
                onChange={(e) => setRemarkInput(e.target.value)}
                placeholder="Enter remark"
              />

              {/* Yes/No buttons */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 2,
                }}
              >
                <Button
                  color={actionType === "Approved" ? "success" : "error"}
                  size="small"
                  onClick={() => {
                    if (!remarkInput.trim()) {
                      toast.error("Remark is required!");
                      return;
                    }
                    // ✅ Reject with remark
                    handleApprove({
                      ...PaymentToApprove,
                      status: actionType,
                      remarks: remarkInput,
                    });
                    setApproveAnchorEl(null);
                    setPaymentToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForIndentId(null);
                    setActionType(null);
                  }}
                >
                  Yes
                </Button>
                <Button
                  size="small"
                  onClick={() => {
                    setApproveAnchorEl(null);
                    setPaymentToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForIndentId(null);
                    setActionType(null);
                  }}
                >
                  No
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Do you want to approve or reject this Payment Voucher?
              </Typography>

              {/* Approve/Reject buttons */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 2,
                }}
              >
                <Button
                  color="success"
                  size="small"
                  onClick={() => {
                    // ✅ Direct Approve
                    setShowRemarkForIndentId(
                      PaymentToApprove?.payment_voucher_no
                    );
                    setActionType("Approved");
                  }}
                >
                  Approve
                </Button>
                <Button
                  color="error"
                  size="small"
                  onClick={() => {
                    // ✅ Switch to remark input mode
                    setShowRemarkForIndentId(
                      PaymentToApprove?.payment_voucher_no
                    );
                    setActionType("Rejected");
                  }}
                >
                  Reject
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Popover>

      {/* =========================EditModal========================== */}

      <Modal open={editModalOpen} onClose={() => setEditModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "600px",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header */}
          <Box sx={{ p: 2, borderBottom: "1px solid #ddd" }}>
            <Typography variant="h6" component="h2">
              Edit Daily Payment
            </Typography>
          </Box>
          <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
            <Box
              sx={{
                mb: 2,
                backgroundColor: "#f5f7fa",
                borderRadius: 2,
                border: "1px solid #e0e0e0",
                p: 2,
              }}
            >
              <Grid container spacing={2}>
                {/* Row 1 */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Voucher No."
                    name="payment_number"
                    value={editFormData.payment_number || ""}
                    size="small"
                    disabled
                    sx={{ width: 500 }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Invoice No."
                    name="invoice_number"
                    value={editFormData.invoice_number || ""}
                    onChange={handleEditChange}
                    size="small"
                    error={!!formErrors.invoice_number}
                    sx={{ width: 500 }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Invoice Date"
                    name="invoice_date"
                    type="date"
                    value={editFormData.invoice_date || ""}
                    onChange={handleEditChange}
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    error={!!formErrors.invoice_date}
                    sx={{ width: 500 }}
                  />
                </Grid>
                {/* ==== Radio Group Row ==== */}
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      Select Voucher Type
                    </FormLabel>
                    <RadioGroup
                      row
                      value={editFormData.voucher_type || ""}
                      onChange={(e) =>
                        setEditFormData((prev) => ({
                          ...prev,
                          voucher_type: e.target.value,
                        }))
                      }
                    >
                      <FormControlLabel
                        value="journal"
                        control={<Radio />}
                        label="Journal Voucher"
                      />
                      <FormControlLabel
                        value="purchase"
                        control={<Radio />}
                        label="Purchase Voucher"
                      />
                      <FormControlLabel
                        value="expense"
                        control={<Radio />}
                        label="Expense"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                {/* ==== Conditionally Render Dropdown ==== */}
                {editFormData.voucher_type === "journal" && (
                  <Grid item xs={12}>
                    <Autocomplete
                      options={generalVoucherData}
                      getOptionLabel={(option) => option.gen_voucher_no || ""}
                      value={
                        (Array.isArray(generalVoucherData) &&
                          generalVoucherData.find(
                            (d) =>
                              d.gen_voucher_no === editFormData.journal_voucher
                          )) ||
                        null
                      }
                      onChange={(e, newValue) => {
                        if (newValue) {
                          setEditFormData((prev) => ({
                            ...prev,
                            journal_voucher: newValue.gen_voucher_no || "",
                            division: newValue.division || "",
                            division_name: newValue.division_name || "",
                            project: newValue.project?.id || "",
                            project_name: newValue.project?.project_name || "",
                            imprest: newValue.imprest || "",
                            expense: newValue.expense || "",
                            amount: newValue.amount?.toFixed(2) || "",
                          }));
                        } else {
                          // Reset all when cleared
                          setEditFormData((prev) => ({
                            ...prev,
                            journal_voucher: "",
                            division: "",
                            division_name: "",
                            project: "",
                            project_name: "",
                            imprest: "",
                            expense: "",
                            amount: "",
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Journal Voucher No"
                          size="small"
                          error={!!formErrors.transporter_name}
                          helperText={formErrors.transporter_name}
                          sx={{ width: 500 }}
                        />
                      )}
                    />
                  </Grid>
                )}

                {editFormData.voucher_type === "purchase" && (
                  <Grid item xs={12}>
                    <Autocomplete
                      options={purchaseVoucherData}
                      getOptionLabel={(option) =>
                        option.purchase_voucher_no || ""
                      }
                      value={
                        (Array.isArray(purchaseVoucherData) &&
                          purchaseVoucherData.find(
                            (d) =>
                              d.purchase_voucher_no ===
                              editFormData.purchase_voucher
                          )) ||
                        null
                      }
                      onChange={(e, newValue) => {
                        if (newValue) {
                          setEditFormData((prev) => ({
                            ...prev,
                            purchase_voucher:
                              newValue.purchase_voucher_no || "",
                            division: newValue.division || "",
                            division_name: newValue.division_name || "",
                            project: newValue.project || "",
                            project_name: newValue.project_name || "",
                            supplier: newValue.supplier || "",
                            supplier_name: newValue.supplier_name || "",
                            amount: newValue.amount?.toFixed(2) || "",
                          }));
                        } else {
                          // Reset all when cleared
                          setEditFormData((prev) => ({
                            ...prev,
                            purchase_voucher: "",
                            division: "",
                            division_name: "",
                            project: "",
                            project_name: "",
                            supplier: "",
                            supplier_name: "",
                            amount: "",
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Purchase Voucher No"
                          size="small"
                          error={!!formErrors.transporter_name}
                          helperText={formErrors.transporter_name}
                          sx={{ width: 500 }}
                        />
                      )}
                    />
                  </Grid>
                )}
                {(editFormData.voucher_type === "purchase" ||
                  editFormData.voucher_type === "journal") && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Project"
                        name="project_name"
                        size="small"
                        value={editFormData.project_name || ""}
                        disabled
                        sx={{ width: 500 }}
                      />
                    </Grid>
                  )}
                {(editFormData.voucher_type === "purchase" ||
                  editFormData.voucher_type === "journal") && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Division"
                        name="division_name"
                        size="small"
                        value={editFormData.division_name || ""}
                        disabled
                        sx={{ width: 500 }}
                      />
                    </Grid>
                  )}
                {editFormData.voucher_type === "purchase" && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Supplier"
                      name="supplier_name"
                      size="small"
                      value={editFormData.supplier_name || ""}
                      disabled
                      sx={{ width: 500 }}
                    />
                  </Grid>
                )}
                {editFormData.voucher_type === "expense" && (
                  <>
                    {/* Expense Autocomplete */}
                    <Grid item xs={12}>
                      <Autocomplete
                        options={expenses || []}
                        getOptionLabel={(option) => option.expense || ""}
                        value={
                          expenses?.find(
                            (expense) =>
                              expense.expense_id === editFormData.expense
                          ) || null
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setEditFormData((prev) => ({
                              ...prev,
                              expense: newValue.expense_id || "",
                              expense_name: newValue.expense || "",
                            }));
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Expense"
                            size="small"
                            sx={{ width: 500 }}
                          />
                        )}
                      />
                    </Grid>

                    {/* Amount Input Field */}
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Amount"
                        name="amount"
                        size="small"
                        type="number"
                        value={editFormData.amount || ""}
                        onChange={handleEditChange}
                        inputProps={{ min: 0, step: 0.01 }}
                        sx={{ width: 500 }}
                      />
                    </Grid>
                  </>
                )}
                {/* ==== Journal Voucher specific fields ==== */}
                {editFormData.voucher_type === "journal" && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Imprest Acc"
                      name="imprest"
                      size="small"
                      value={editFormData.imprest || ""}
                      disabled
                      sx={{ width: 500 }}
                    />
                  </Grid>
                )}
                {editFormData.voucher_type === "journal" && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Expense"
                      name="expense"
                      size="small"
                      value={editFormData.expense || ""}
                      disabled
                      sx={{ width: 500 }}
                    />
                  </Grid>
                )}

                {/* ==== Cash / Bank Radio ==== */}
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">Payment Mode</FormLabel>
                    <RadioGroup
                      row
                      value={editFormData.payment_mode || ""}
                      onChange={(e) =>
                        setEditFormData((prev) => ({
                          ...prev,
                          payment_mode: e.target.value,
                        }))
                      }
                    >
                      <FormControlLabel
                        value="Cash"
                        control={<Radio />}
                        label="Cash"
                      />
                      <FormControlLabel
                        value="Bank"
                        control={<Radio />}
                        label="Bank"
                      />
                      <FormControlLabel
                        value="Cheque"
                        control={<Radio />}
                        label="Cheque/NEFT/RTGS/UPI"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                {/* ==== Conditionally show TextField ==== */}
                {editFormData.payment_mode === "Cash" && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Cash Details"
                      name="description"
                      value={editFormData.description || ""}
                      onChange={handleEditChange}
                      size="small"
                      sx={{ width: 500 }}
                    />
                  </Grid>
                )}

                {editFormData.payment_mode === "Cheque" && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Bank Details"
                      name="description"
                      value={editFormData.description || ""}
                      onChange={handleEditChange}
                      size="small"
                      placeholder="NEFT/RTGS/UPI/Cheque"
                      sx={{ width: 500 }}
                    />
                  </Grid>
                )}

                {editFormData.payment_mode === "Bank" && (
                  <Grid item xs={12}>
                    <Autocomplete
                      options={bankDetails}
                      getOptionLabel={(option) => option.account_number}
                      value={bankDetails.find(
                        (option) => option.id === editFormData.bank
                      )}
                      onChange={(e, newValue) => {
                        setEditFormData((prev) => ({
                          ...prev,
                          bank: newValue ? newValue.id : null,
                        }));
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Bank Details"
                          size="small"
                          sx={{ width: 500 }}
                        />
                      )}
                    />
                  </Grid>
                )}

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Narration"
                    name="narration"
                    value={editFormData.narration || ""}
                    onChange={handleEditChange}
                    size="small"
                    sx={{ width: 500 }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    type="file"
                    name="attachment"
                    id={`attachment-${editFormData.id}`}
                    onChange={handleEditChange}
                    label="Attachment"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    error={!!formErrors.attachment}
                    sx={{ width: 500 }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}></Grid>
              </Grid>
            </Box>
          </Box>
          <Box
            sx={{
              borderTop: "1px solid #ddd",
              p: 2,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              backgroundColor: "#fafafa",
              gap: 1,
            }}
          >
            <Button
              variant="outlined"
              color="error"
              onClick={() => setEditModalOpen(false)}
              size="small"
              sx={{ px: 2 }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleEditSave}
              size="small"
              sx={{ px: 2 }}
            >
              Update
            </Button>
          </Box>
        </Box>
      </Modal>
      {/* =========================ViewModal========================== */}

      <Modal open={viewModalOpen} onClose={() => setViewModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "95%",
            maxWidth: "1000px",
            bgcolor: "background.paper",
            borderRadius: 1,
            boxShadow: 24,
            p: 3,
            overflowY: "auto",
            maxHeight: "90vh",
          }}
        >
          <h2>View Payment Voucher</h2>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
            {Object.entries(viewData).map(([key, value]) => (
              <TextField
                key={key}
                label={key.replace(/_/g, " ").toUpperCase()}
                value={value}
                fullWidth
                InputProps={{ readOnly: true }}
                size="small"
                sx={{ flex: 1, minWidth: 180 }}
                margin="dense"
              />
            ))}
          </Box>

          <Box sx={{ textAlign: "right", mt: 2 }}>
            <Button
              onClick={() => setViewModalOpen(false)}
              color="primary"
              variant="contained"
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default PaymentVouchers;
